import { Navigate } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';

const PermissionGuard = ({ permission, children }) => {
  const hasPermission = usePermission(permission);

  if (!hasPermission) return <Navigate to="/unauthorized" replace />;

  return children;
};

export default PermissionGuard;
